import React, {
  forwardRef,
  Ref,
  useId,
  useState,
  useImperativeHandle,
  useCallback,
} from 'react';

// Types
import { InputRoidProps, ImperativeRefInputRoid } from './types';

// Components Styled
import { Container, InputsContainer, InputValue, Label } from './styles';

// Media
import { useIsLandscapeTablet } from '../../../hooks/useMediaBreakPoints';
import isEqual from 'lodash.isequal';

/**
 * Primary UI component for user interaction
 */
function InputRoid(
  {
    label,
    disabled,
    onChangeInputRoid,
    roid = ['', '', '', ''],
    ...props
  }: InputRoidProps,
  innerRef: Ref<ImperativeRefInputRoid>
): JSX.Element {
  const [inputValues, setInputValues] = useState(roid);

  const onChangeInput = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, i: number) => {
      setInputValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[i] = event.target.value;
        onChangeInputRoid(newValues);
        return newValues;
      });
    },
    []
  );

  useImperativeHandle(innerRef, () => ({
    clearSelected: () => {
      setInputValues(['', '', '', '']);
    },
  }));

  const id = useId();

  const isLandscapeTablet = useIsLandscapeTablet();

  return (
    <Container {...props}>
      {label && (
        <Label
          component={'label'}
          htmlFor={`${id}-roid-input`}
          colorText="black"
          size={isLandscapeTablet ? 'XS' : 'S'}
        >
          {label}
        </Label>
      )}
      <InputsContainer>
        <InputValue
          id={`${id}-roid-input`}
          type="text"
          disabled={disabled}
          maxLength={2}
          placeholder={'00'}
          value={inputValues[0]}
          onChange={(event) => {
            onChangeInput(event, 0);
          }}
          onKeyDown={(e) => {
            /[+*./,\\-]/.test(e.key) && e.preventDefault();
          }}
        />
        <InputValue
          id={`${id}-roid-input`}
          type="text"
          disabled={disabled}
          maxLength={7}
          placeholder={'0000000'}
          value={inputValues[1]}
          onChange={(event) => onChangeInput(event, 1)}
          onKeyDown={(e) => {
            /[+*./,\\-]/.test(e.key) && e.preventDefault();
          }}
        />
        <InputValue
          id={`${id}-roid-input`}
          type="text"
          disabled={disabled}
          maxLength={4}
          placeholder={'0000'}
          value={inputValues[2]}
          onChange={(event) => onChangeInput(event, 2)}
          onKeyDown={(e) => {
            /[+*./,\\-]/.test(e.key) && e.preventDefault();
          }}
        />
        <InputValue
          id={`${id}-roid-input`}
          type="text"
          disabled={disabled}
          maxLength={2}
          placeholder={'00'}
          value={inputValues[3]}
          onChange={(event) => onChangeInput(event, 3)}
          onKeyDown={(e) => {
            /[+*./,\\-]/.test(e.key) && e.preventDefault();
          }}
        />
      </InputsContainer>
    </Container>
  );
}

export default React.memo(forwardRef(InputRoid), isEqual);
